// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"f978c786","416":"1ea212bf","587":"6cc65993","821":"a6bf3da8","842":"a62565b4"}[chunkId] + ".chunk.js";
};